
import React from 'react';
import { AIStaffMember } from '@/lib/types';
import { useNavigate } from 'react-router-dom';
import StaffHeader from './StaffHeader';
import CurrentStaffList from './CurrentStaffList';
import AvailableStaffGrid from '@/components/staff/AvailableStaffGrid';

interface StaffListViewProps {
  isLoading: boolean;
  allAIStaff: AIStaffMember[];
}

const StaffListView: React.FC<StaffListViewProps> = ({ isLoading, allAIStaff }) => {
  const navigate = useNavigate();
  
  const handleSelectCandidate = (candidateId: number) => {
    navigate(`/app/hiring?candidate=${candidateId}`);
  };
  
  return (
    <>
      <StaffHeader title="Staff Management" showBackButton={false} />
      
      {/* Current AI Staff Section */}
      <div className="mb-10">
        <h2 className="text-xl font-semibold mb-4">Your Current AI Staff</h2>
        <CurrentStaffList isLoading={isLoading} allAIStaff={allAIStaff} />
      </div>
      
      {/* Available AI Assistants Section */}
      <div>
        <h2 className="text-xl font-semibold mb-4">Available AI Assistants</h2>
        <AvailableStaffGrid onSelectCandidate={handleSelectCandidate} />
      </div>
    </>
  );
};

export default StaffListView;
